import Styles from './PostPreviewModal.module.scss'
import { DesignChannel } from 'components/NewFileModal/Types'
import { IntegrationPicker } from './IntegrationPicker'
import { DateTimePicker } from 'blaze-ui/DateTimePicker/DateTimePicker'
import { TikTokPostSettings } from './components/TikTokPostSettings'
import { usePostPreviewContext } from './PostPreviewContext'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { SchedulingButtons } from './SchedulingButtons'
import { YoutubePostDetails } from './components/Youtube/YoutubePostDetails'

interface Props {
  fileId: string
  channel: DesignChannel
}

export const SchedulingDetails = ({ fileId, channel }: Props) => {
  const { scheduledPost, provider, providerName, dateTime, setDateTime } = usePostPreviewContext()

  if (!scheduledPost || !provider || !providerName) return null

  return (
    <div className={Styles.integrationContainer}>
      <div className={Styles.postDetails}>
        <IntegrationPicker scheduledPost={scheduledPost} providerName={providerName} provider={provider} />
        <DateTimePicker dateTime={dateTime} setDateTime={setDateTime} responsive inline />
        {provider === ExternalIntegrationEnum.TikTok && (
          <TikTokPostSettings scheduledPost={scheduledPost} channel={channel} />
        )}
        {provider === ExternalIntegrationEnum.YouTube && (
          <YoutubePostDetails fileId={fileId} channel={channel} scheduledPost={scheduledPost} />
        )}
        <ResponsiveDesign.Desktop>
          <SchedulingButtons fileId={fileId} channel={channel} />
        </ResponsiveDesign.Desktop>
      </div>
    </div>
  )
}
